<p-toast
  [key]="APP_TOAST_KEY"
  [preventOpenDuplicates]="true"
>
  <ng-template
    let-message
    pTemplate="message"
  >
    <pfx-toast-content [message]="message"></pfx-toast-content>
  </ng-template>
</p-toast>

<pfx-app-sidebars-container></pfx-app-sidebars-container>

<router-outlet></router-outlet>
